import React from 'react';
import './Footer.css';

export const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-info">
              <p className="footer-copyright">
                © {currentYear} Skyangel. Todos los derechos reservados.
              </p>
            </div>
          </div>
          
          <div className="footer-section">
            <div className="footer-description-center">
              <p className="footer-description">
                Sistema de gestión y seguimiento de dispositivos
              </p>
            </div>
          </div>
          
          <div className="footer-section">
            <div className="footer-links">
              <span className="footer-powered">
                Powered by Skyangel Technology
              </span>
            </div>
          </div>
        </div>
        
        <div className="footer-bottom">
          <div className="footer-divider"></div>
          <p className="footer-legal">
            Este sistema es propiedad de Skyangel. El uso no autorizado está prohibido.
          </p>
        </div>
      </div>
    </footer>
  );
};
